import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { PoModule } from '@po-ui/ng-components';
import { MainService } from 'src/app/app.service';
import { QueryChatComponent } from './query-chat.component';
import { NotificationItemComponent } from '../notification-item/notification-item.component';
import { PoCodeEditorModule } from '@po-ui/ng-code-editor';
import { QueryChatService } from './query-chat.service';
import { AiChatComponent } from '@engpro/ai-chat';
import { ChatbotService } from './components/chatbot-ai/chatbot.service';

@NgModule({
  declarations: [
    QueryChatComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    PoModule,
    PoTemplatesModule,
    PoCodeEditorModule,
    NotificationItemComponent,
    AiChatComponent
  ],
  providers: [
    MainService,
    QueryChatService,
    ChatbotService
  ]
})
export class QueryChatModule { }
